import { render, staticRenderFns } from "./detailPC.vue?vue&type=template&id=2c5b48b5&scoped=true&"
import script from "./detailPC.vue?vue&type=script&lang=js&"
export * from "./detailPC.vue?vue&type=script&lang=js&"
import style0 from "./detailPC.vue?vue&type=style&index=0&id=2c5b48b5&scoped=true&lang=css&"
import style1 from "./detailPC.vue?vue&type=style&index=1&id=2c5b48b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5b48b5",
  null
  
)

export default component.exports